import classNames from 'classnames';
import { useIntl } from 'react-intl';
import IconTile from '@alltrails/denali/components/IconTile';
import TableRow from '@alltrails/denali/components/TableRow';
import Place from '@alltrails/denali/icons/Place';
import type { CoordinatesResult } from '@alltrails/types/AlgoliaResults';
import styles from './styles/styles.module.scss';

type CoordinatesResultContentProps = {
  result: CoordinatesResult;
};

const CoordinatesResultContent = ({ result }: CoordinatesResultContentProps) => {
  const intl = useIntl();
  const icon = <IconTile icon={{ Component: Place }} />;

  return (
    <TableRow
      className={classNames(styles.listItemContent, styles.noDescription)}
      leftContent={icon}
      label={
        <div className={styles.label}>
          {result.latitude}, {result.longitude}
        </div>
      }
      description={intl.formatMessage({ defaultMessage: 'Coordinates' })}
    />
  );
};

export default CoordinatesResultContent;
